import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/audioImg.png';
import _imports_1 from '@/assets/img/audioImg1.png';
const _withScopeId = n => (_pushScopeId("data-v-383ec5d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-common-page"
};
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "main-title"
}, " 泰戈智慧物联管理平台 ", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "intro-section"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "intro-content"
}, [/*#__PURE__*/_createElementVNode("p", null, "泰戈智慧物联管理平台是我县推动城市基础设施数字化升级、强化燃气行业精准监管的核心平台。"), /*#__PURE__*/_createElementVNode("p", null, " 系统基于物联网与数据智能技术，构建了从监测预警到远程控制的闭环管理机制，实现对管网运行状态的实时感知、智能调度与安全管控，全面提升了燃气供应的稳定性、应急响应效率与行业管理水平，为城市能源安全与居民用气保障提供了坚实支撑。 ")])], -1));
const _hoisted_7 = {
  class: "button-section"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img img2"
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-text"
}, "综合管理平台", -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img img1"
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-text"
}, "管网综合态势", -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img img3"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-text"
}, "燃气巡检平台", -1));
const _hoisted_16 = [_hoisted_14, _hoisted_15];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.audioSrc ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "audio-icon-wrapper",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.toggleAudio && $options.toggleAudio(...args))
  }, [_createElementVNode("div", {
    class: _normalizeClass(["audio-icon", {
      'playing': $data.isPlaying
    }])
  }, [!$data.isPlaying ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : (_openBlock(), _createElementBlock("img", _hoisted_3))], 2), _createElementVNode("audio", {
    ref: "audioPlayer",
    src: $data.audioSrc,
    loop: "",
    onError: _cache[0] || (_cache[0] = (...args) => $options.handleAudioError && $options.handleAudioError(...args)),
    onPlay: _cache[1] || (_cache[1] = $event => $data.isPlaying = true),
    onPause: _cache[2] || (_cache[2] = $event => $data.isPlaying = false)
  }, null, 40, _hoisted_4)])) : _createCommentVNode("", true), _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
    class: "function-btn",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.enterManagePlatform && $options.enterManagePlatform(...args))
  }, _hoisted_10), _createElementVNode("div", {
    class: "function-btn",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.enterPipelineStatus && $options.enterPipelineStatus(...args))
  }, _hoisted_13), _createElementVNode("div", {
    class: "function-btn",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.enterInspectionPlatform && $options.enterInspectionPlatform(...args))
  }, _hoisted_16)])]);
}